import { NgModule, ValueProvider } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListBoxComponent } from './listbox.component';
import { ListBoxModule } from './listbox.module';
/**
 * NgModule definition for the ListBox component with providers.
 */
export class ListBoxAllModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule, ListBoxModule],
    exports: [
        ListBoxModule
    ],
    providers:[
        
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ListBoxAllModule_tsickle_Closure_declarations() {
/** @type {?} */
ListBoxAllModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ListBoxAllModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
